import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import Loading from "../../../../common/components/Loading";
import NetbillingContextProvider, {
    NetbillingContext,
    ACTIONS,
} from "../../context/NetbillingContextProvider";
import { getPathName, changeCurrancyFormat, changeDataFormat, decode_utf8, getSignedIdStatus, getCurrentTime } from '../../../../common/utils/utilsFunc'
import { LiferayService } from '../../../../common/services/liferay'
import TableLastTickets from '../TableLastTickets';
import arTitles from '../../../../common/services/mock/title.json'
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const DetailTicketPublic = ({ props }) => {
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [errorShow, setErrorShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [tableToggle, setTableToggle] = React.useState(false);
    const [listTickets, setListTickets] = React.useState([])
    const [state, dispatch] = React.useContext(NetbillingContext);
    const [newArrayExcel, setNewArrayExcel] = React.useState()
    const [newArray, setNewArray] = React.useState()
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModal2, setVisibleModal2] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => { 
            setVisibleModal(false);
            setVisibleModal2(false)
         }
    });
    const [values, setValues] = React.useState({});
    const [errorCli, setErrorCli] = React.useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    let propsLabelInfoContent = {
        "setVisibleModal": setVisibleModal2,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModal2,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentTextInfo
    }

    React.useEffect(() => {
        if (listTickets) {
            setLoading(false);

            dispatch({
                payload: null,
                type: ACTIONS.SET_IDCTACTO,
            })

            let newArrayExcel = JSON.parse(JSON.stringify(listTickets))
            newArrayExcel = [...newArrayExcel, newArrayExcel?.map((aux) => {
                if (aux.FechaEmision.split('-')[0].length === 4) {
                    aux.FechaEmision = changeDataFormat(aux.FechaEmision);
                }
                if (aux.TotalPagar[0] !== '$') {
                    aux.TotalPagar = changeCurrancyFormat(aux.TotalPagar);
                }
            })]


            //new array to page
            let newArray = JSON.parse(JSON.stringify(listTickets))
            newArray = [...newArray, newArray?.map((aux) => {
                if (aux.FechaEmision.split('-')[0].length === 4) {
                    aux.FechaEmision = changeDataFormat(aux.FechaEmision);
                }
                if (aux.TotalPagar[0] !== '$') {
                    aux.TotalPagar = changeCurrancyFormat(aux.TotalPagar);
                }
            })]
            newArrayExcel?.splice(props.qnt_list_boletas, 1)
            newArray?.splice(props.qnt_list_boletas, 1)
            newArrayExcel && setNewArrayExcel(newArrayExcel)
            newArray && setNewArray(newArray)
        }

    }, [listTickets])

    let newArrTitle = arTitles[getPathName()]?.map((item) => item.label);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
            setErrorShow(false);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleButton() {
        if (!values.idClient) {
            setErrorShow(true)
            setErrorCli(true)
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
            dispatch({
                payload: null,
                type: ACTIONS.SET_IDCTACTO,
            })
        } else if (!verifReCaptcha) {
            setErrorShow(true)
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
            dispatch({
                payload: null,
                type: ACTIONS.SET_IDCTACTO,
            })
        } else {
            setLoading(true);
            setErrorCli(false)
            dispatch({
                payload: values.idClient,
                type: ACTIONS.SET_IDCTACTO,
            })

        }
    }

    React.useEffect(() => {
        dispatch({
            payload: true,
            type: ACTIONS.SET_LOAD_PAGE,
        });

    }, []);

    React.useEffect(() => {
        if (state.listTickets?.code === 0) {
            setLoading(false);
            setTableToggle(true)
            setListTickets(state.listTickets.items)
            setErrorShow(false)
        } else {
            dispatch({
                payload: null,
                type: ACTIONS.SET_IDCTACTO,
            })
            setLoading(false);
            if (state.listTickets?.message && state.listTickets?.status !== 500) {
                setErrorShow(true);
                props.setGlobalAlert(state.listTickets.message, "warning", true, "Advertencia");
            } else if (state.listTickets?.status === 500) {
                setErrorShow(true);
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
            }
        }
    }, [state.listTickets]);

    function getDetailTicket(Array) {
        let dateEmission = new Date(changeDataFormat(Array[1]));
        let dateLimitEmission = new Date(changeDataFormat(props.last_year_tickets_emission));
        if (dateEmission <= dateLimitEmission) {
            setVisibleModal(true);
        } else {
            setVisibleModal(false);
            setLoading(true);
            LiferayService.getDetailTicketPDF(props.base_url_api,
                values.idClient, props.url_ws_empresa,
                props.codigo_empresa, Array[0], getSignedIdStatus(),
                decode_utf8(props.title_pdf_ticket), Array[1])
                .then((response) => {
                    setLoading(false);
                    setErrorShow(false);
                    if (response.status) {
                        if (response.message && response.status !== 500) {
                            props.setGlobalAlert(response.message, "warning", true, "Advertencia");
                        } else {
                            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                        }
                    } else {
                        response.data.blob().then(blob => {
                            const fileURL = window.URL.createObjectURL(blob);
                            let link = document.createElement('a');
                            link.download = `DetalleFacturacion_${getCurrentTime()}.pdf`;
                            link.href = fileURL;
                            link.click();
                        });
                    }
                    dispatch({
                        payload: response,
                        type: ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_ERROR,
                    });
                })
                .catch((error) => {
                    dispatch({
                        payload: error,
                        type: ACTIONS.SET_ERROR,
                    });
                    dispatch({
                        payload: null,
                        type: ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF,
                    });
                })
        }
    }
    
    React.useEffect(() => {
        if (state.detailClient) {
          if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM);
            } else {
                setDetailClientJson([]);
                props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) , "warning", true, "Advertencia");
                setLoading(false);
            }
          } else {
            setLoading(false);
            setDetailClientJson([]);
            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          }
        }
    }, [state.detailClient])

    return (
        <>
            <CGE.Panel
                title={decode_utf8(props.titulo_last_tickets_public)}
                description={decode_utf8(props.descripcione_last_tickets_public)}
            >
                <CGE.DetailClient
                    props={{
                        handleChange: (e) => {
                            setTableToggle(false);
                            setValues({ ...values, idClient: e.target.value });
                        },
                        horizontal: true,
                        hasError: errorCli,
                        msgError: "Debe ingresar el Nro. de Cliente.",
                        idClient: values.idClient,
                        idFormElement: "clientId",
                        labelName: "Número de Cliente:",
                        mandatoryElement: true,
                        placeholder: "Ingresar el numero de cliente",
                        valuePub: values.idClient,
                        propsLabelInfoContent:propsLabelInfoContent
                    }}
                    propsDetail={{
                        fullNameClient: "",
                        comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                        calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                        nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                        dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                            ${detailClientJson?.PISO}` : "",
                        ctaCtoClient: detailClientJson?.CTA_CTO
                    }}
                />
                <div className="detail-client-horizontal">
                    <CGE.Spacing type="md" />
                    <CGE.FieldRecaptcha
                        horizontal={true}
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                    />
                </div>
                <div>
                    <CGE.Button
                        className="mx-auto"
                        label="Buscar"
                        onClick={() => {
                            handleButton()
                        }}
                    />
                </div>
                <div>
                    {tableToggle && !errorShow &&
                        <TableLastTickets
                            props=
                            {
                                { ...props, newArray, newArrTitle, errorShow, getDetailTicket, newArrayExcel }
                            }
                        />}
                </div>
            </CGE.Panel>
            {loading && <Loading />}
            {visibleModal && !loading && (
                <AlertModal
                    titleModal="Advertencia"
                    msgModal={`${props.text_error_last_year_tickets_emission} ${props.last_year_tickets_emission}`}
                    observer={observer}
                    onClose={onClose}
                    status="warning"
                />
            )}

        </>
    )
}

const DetailTicketPublicWithProvider = ({ props }) => (
    <NetbillingContextProvider>
        <DetailTicketPublic props={props} />
    </NetbillingContextProvider>
);
export default DetailTicketPublicWithProvider;
